const allModifiers = {
  sameWidth: {
    name: "sameWidth",
    enabled: !0,
    fn: ({ state }) => {
      const referenceWidth = state.rects.reference.width;
      state.rects.popper.width < referenceWidth && (state.styles.popper.width = `${referenceWidth}px`, state.styles.popper.maxWidth = `${referenceWidth}px`);
    },
    phase: "beforeWrite",
    requires: ["computeStyles"]
  }
}, selectModifiers = [
  allModifiers.sameWidth
];
export {
  selectModifiers
};
//# sourceMappingURL=popperModifiers.js.map
